import { authFetch, previewFetch } from './api';

export const fetchDashboardData = async () => {
  const response = await authFetch('/api/artists/me');
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    const err = new Error(error.message || 'Impossible de charger les donnees du tableau de bord.');
    err.status = response.status;
    throw err;
  }
  return response.json();
};

export const updateProfile = async (updates) => {
  const response = await authFetch('/api/artists/me', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(updates)
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    const err = new Error(error.message || 'Impossible de mettre a jour le profil.');
    err.status = response.status;
    throw err;
  }

  return response.json();
};

export const generateTelegramCode = async () => {
  const response = await authFetch('/api/artists/me/telegram-link-code', {
    method: 'POST'
  });

  const result = await response.json();

  if (!response.ok) {
    const err = new Error(result.message || 'Impossible de generer le code Telegram.');
    err.status = response.status;
    throw err;
  }

  return result.telegram_link_code;
};

export const fetchPublicArtistProfile = async (slug) => {
  const response = await previewFetch(`/api/artists/${encodeURIComponent(slug)}`);
  const result = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(result.message || 'Artiste introuvable.');
  }

  return result;
};
